<template>
  <!-- 人员信息 -->
  <div class="edu_pages">
    <div class="edu_pages_content_box">
      <div class="edu_page_title_box">
        <div class="title_box">
          <div class="color_lump_box"></div>
          <span>人员管理</span>
        </div>
        <div class="edu_operation_box">
          <el-select
            style="width:200px"
            v-model="listRequestData.departmentId"
            placeholder="请选择所属部门"
            size="mini"
            clearable
          >
            <el-option
              v-for="item in departmentList"
              :key="item.departmentId"
              :label="item.departmentName"
              :value="item.departmentId"
            >
            </el-option>
          </el-select>
          <el-input
            style="width:200px;margin-left:5px"
            placeholder="请输入手机号"
            v-model.trim="listRequestData.userPhone"
            size="mini"
            clearable
          >
          </el-input>
          <el-input
            style="width:200px;margin-left:5px"
            placeholder="请输入用户名"
            v-model.trim="listRequestData.userName"
            size="mini"
            clearable
          >
          </el-input>
          <div class="search_icon_box button-box" @click="getDataList()">
            <div></div>
            <span>搜索</span>
          </div>
          <div class="add_icon_box button-box" @click="openAddBox()">
            <div></div>
            <span>新增</span>
          </div>
        </div>
      </div>
      <div class="edu_pages_content_body_box">
        <div class="edu_table_box">
          <el-table
            :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
            :data="dataList.list"
            height="100%"
            class="table_box"
          >
            <el-table-column label="序号" width="70" align="center">
              <template slot-scope="scope">
                {{
                  dataList.pageSize * (dataList.pageNum - 1) + scope.$index + 1
                }}
              </template>
            </el-table-column>
            <el-table-column
              v-if="eduInfo.eduBuresuType == -1"
              prop="loginId"
              label="工号"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.loginId.length < 32">
                  {{ scope.row.loginId ? scope.row.loginId : "" }}
                </span>
                <span v-else>
                  暂无工号
                </span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="loginId"
              v-else
              :label="eduInfo.eduBuresuType == -1 ? '编号' : '登录账号'"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-tooltip placement="top" effect="light">
                  <div slot="content">点击复制</div>
                  <span
                    class="tag-read copy-span"
                    :data-clipboard-text="scope.row.loginId"
                    @click="clickCopy"
                    >{{ scope.row.loginId }}</span
                  >
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="userName"
              label="名称"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>

            <el-table-column
              v-if="eduInfo.eduBuresuType != -1"
              prop="roleName"
              label="角色名称"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="rowData">
                {{
                  rowData.row.roleName ? rowData.row.roleName : "暂无绑定角色"
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="departmentName"
              label="所属部门"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="rowData">
                {{
                  rowData.row.departmentName
                    ? rowData.row.departmentName
                    : "暂无绑定部门"
                }}
              </template>
            </el-table-column>
            <el-table-column
              label="状态"
              width="150"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="rowData">
                <el-tag type="danger" v-if="rowData.row.accountStatus == 0">
                  禁用
                </el-tag>
                <el-tag type="warning" v-else>
                  启用
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center">
              <template slot-scope="rowData">
                <el-link
                  type="primary"
                  @click="editUserInfo(rowData.row.userId)"
                  :underline="false"
                  >编辑</el-link
                >
                <el-divider direction="vertical"></el-divider>
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item class="dropdown_item_box"
                      ><el-link
                        class="link_box"
                        type="primary"
                        :disabled="
                          rowData.row.userId == userInfo.userId ? true : false
                        "
                        @click="delData(rowData.row)"
                        :underline="false"
                        >删除</el-link
                      ></el-dropdown-item
                    >
                    <el-dropdown-item
                      class="dropdown_item_box"
                      divided
                      v-if="rowData.row.accountStatus == 0"
                      ><el-link
                        class="link_box"
                        type="primary"
                        @click="enableEduUser(rowData.row.userId)"
                        :underline="false"
                        >启用</el-link
                      ></el-dropdown-item
                    >
                    <el-dropdown-item v-else class="dropdown_item_box"
                      ><el-link
                        class="link_box"
                        type="primary"
                        @click="disableEduUser(rowData.row.userId)"
                        :underline="false"
                        >禁用</el-link
                      ></el-dropdown-item
                    >
                    <el-dropdown-item class="dropdown_item_box"
                      ><el-link
                        v-if="eduInfo.eduBuresuType == -1"
                        class="link_box"
                        type="primary"
                        @click="editJob(rowData.row)"
                        :underline="false"
                        >工号编辑</el-link
                      ></el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="edu_pagination_box">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            :current-page="dataList.pageNum"
            :page-sizes="[20, 50, 100, 200]"
            :page-size="listRequestData.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="dataList.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <job-number-edit-dialog
      :showDialog="jShowDialog"
      :dialogInfo="jDialogInfo"
      @close="jClose"
      @saveClick="jSaveClick"
    ></job-number-edit-dialog>
    <user-add-or-edit-dialog
      :showDialog="uShowDialog"
      :dialogInfo="uDialogInfo"
      :dialogType="uDialogType"
      @close="uClose"
      @saveClick="uSaveClick"
    ></user-add-or-edit-dialog>
  </div>
</template>

<script>
import JobNumberEditDialog from "./components/JobNumberEditDialog.vue";
import UserAddOrEditDialog from "./components/UserAddOrEditDialog.vue";
export default {
  name: "",
  components: {
    JobNumberEditDialog,
    UserAddOrEditDialog
  },
  props: {},
  data() {
    return {
      listRequestData: {
        eduId: this.$store.getters.getEduData.eduId,
        pageNum: 1,
        pageSize: 20,
        userPhone: "",
        userName: "",
        departmentId: ""
      },
      dataList: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },
      departmentList: [],
      jShowDialog: false,
      jDialogInfo: {},
      uShowDialog: false,
      uDialogInfo: {
        userId: "",
        eduId: this.$store.getters.getEduData.eduId,
        roleId: 0,
        userName: "",
        userPhone: "",
        userPwd: "",
        departmentId: "",
        userIdNumber: "",
        landlineNumber: "",
        email: "",
        sex: 0,
        officeLists: ""
      },
      uDialogType: "add"
    };
  },
  watch: {},
  computed: {
    eduInfo() {
      return JSON.parse(sessionStorage.getItem("eduInfo"));
    },
    userInfo() {
      return JSON.parse(sessionStorage.getItem("userInfo"));
    }
  },
  methods: {
    openAddBox() {
      this.uShowDialog = true;
      this.uDialogType = "add";
      this.clearData();
    },
    handleCurrentChange(val) {
      this.listRequestData.pageNum = val;
      this.getDataList();
    },
    async editUserInfo(id) {
      var requestData = {
        userId: id
      };
      let res = await this.$Http.getEduUserDetails(requestData);
      if (res.code == 200) {
        this.uDialogInfo.userId = res.data.userId || "";
        this.uDialogInfo.roleId = res.data.roleId == 0 ? 0 : res.data.roleId;
        this.uDialogInfo.userName = res.data.userName || "";
        this.uDialogInfo.userPhone = res.data.userPhone || "";
        this.uDialogInfo.userPwd = "";
        this.uDialogInfo.departmentId =
          res.data.departmentId == 0 ? "" : res.data.departmentId;
        this.uDialogInfo.userIdNumber = res.data.userIdNumber || "";
        this.uDialogInfo.landlineNumber = res.data.landlineNumber || "";
        this.uDialogInfo.email = res.data.email || "";
        this.uDialogInfo.sex = res.data.sex;
        var officeLists = [];
        res.data.officeLists.forEach((item) => {
          officeLists.push(item.positionId);
        });
        this.uDialogInfo.officeLists = officeLists;
        this.uDialogInfo.eduId = this.$store.getters.getEduData.eduId;
        this.uShowDialog = true;
        this.uDialogType = "edit";
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    uClose() {
      this.uShowDialog = false;
      this.clearData();
    },
    clearData() {
      this.uDialogInfo = {
        userId: "",
        eduId: this.$store.getters.getEduData.eduId,
        roleId: 0,
        userName: "",
        userPhone: "",
        userPwd: "",
        departmentId: "",
        userIdNumber: "",
        landlineNumber: "",
        email: "",
        sex: 0,
        officeLists: ""
      };
    },
    uSaveClick(info) {
      if (this.uDialogType == "add") {
        this.addDataInfo(info);
      } else {
        this.editDataAction(info);
      }
    },
    async getDataList() {
      let req;
      if (this.eduInfo.eduBuresuType == -1) {
        req = Object.assign({}, this.listRequestData, {
          eduBuresuType: -1
        });
      } else {
        req = this.listRequestData;
      }
      let res = await this.$Http.getEduUserList(req);
      if (res.code == 200) {
        this.dataList.pageSize = res.data.pageSize;
        this.dataList.pageNum = res.data.pageNum;
        this.dataList.total = res.data.total;
        this.dataList.pages = res.data.pages;
        this.dataList.list = res.data.list || [];
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    editJob(row) {
      this.jShowDialog = true;
      this.jDialogInfo = {
        jobNumber: row.loginId.length < 32 ? row.loginId : '',
        userId: row.userId,
        userName: row.userName
      };
    },
    jClose() {
      this.jShowDialog = false;
    },
    jSaveClick(info) {
      this.addJob(info);
    },
    async addJob(row) {
      let req = {
        jobNumber: row.jobNumber,
        userId: row.userId
      };
      let res = await this.$Http.addJobNumber(req, true);
      if (res.code == 200) {
        this.$message({
          message: res.messsage || "添加成功",
          type: "success"
        });
        this.jShowDialog = false;
        this.getDataList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage || "添加失败",
          type: "error"
        });
      }
    },
    cencelJob() {
      this.getDataList();
    },
    async addDataInfo(info) {
      if (this.eduInfo.eduBuresuType == -1) {
        info.roleId = -2;
        info.eduBuresuType = -1;
      }
      var requestData = JSON.parse(JSON.stringify(info));
      var officeLists = [];
      requestData.officeLists.forEach((element) => {
        officeLists.push({
          positionId: element
        });
      });
      requestData.officeLists = officeLists;
      delete requestData.userId;
      let res = await this.$Http.addEduUser(requestData);
      if (res.code == 200) {
        this.$message({
          message: res.messsage,
          type: "success"
        });
        this.getDataList();
        this.uClose();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    async editDataAction(info) {
      if (this.eduInfo.eduBuresuType == -1) {
        info.eduBuresuType = -1;
      }
      var requestData = JSON.parse(JSON.stringify(info));
      var officeLists = [];
      requestData.officeLists.forEach((element) => {
        officeLists.push({
          positionId: element
        });
      });
      requestData.officeLists = officeLists;
      let res = await this.$Http.addEduUser(requestData);
      if (res.code == 200) {
        this.$message({
          message: res.messsage,
          type: "success"
        });
        this.getDataList();
        this.uClose();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },

    // 禁用
    disableEduUser(dataId) {
      this.$confirm("确定要禁用此用户吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var requestData = {
            userId: [dataId]
          };
          let res = await this.$Http.disableEduUser(requestData, true);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.messsage
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },

    // 启用
    enableEduUser(dataId) {
      this.$confirm("确定要启用此用户吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var requestData = {
            userId: [dataId]
          };
          let res = await this.$Http.enableEduUser(requestData, true);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.messsage
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },

    // 删除数据
    delData(row) {
      this.$confirm("确定要删除吗？删除后的用户将无法恢复", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var requestData = {
            userId: row.userId,
            loginId: row.loginId
          };
          let res;
          if (this.eduInfo.eduBuresuType == -1) {
            //高校的删除
            res = await this.$Http.delCollegeUser(requestData, true);
            console.log("高校删除用户");
          } else {
            //教育局的删除
            res = await this.$Http.delEduUser(requestData, true);
            console.log("教育局删除用户");
          }
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },

    async getDepartmentList() {
      let res = await this.$Http.getEduWholeDepartment({
        eduId: this.$store.getters.getEduData.eduId
      });
      if (res.code == 200) {
        this.departmentList = res.data;
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    }
  },
  created() {
    this.getDataList();
    this.getDepartmentList();
  },
  mounted() {}
};
</script>
<style scoped lang="scss">
input::-webkit-input-placeholder {
  color: #c0c4cc;
}
input::-moz-input-placeholder {
  color: #c0c4cc;
}
input::-ms-input-placeholder {
  color: #c0c4cc;
}
@import "../../../../public/css/edu_pages.scss";
</style>
